import cn from 'classnames';

import ScaleMotion from 'components/Motion/ScaleMotion';

import { IconComponent } from './../../Icon/IconComponent';
import StatusPill from './../../Pills/StatusPills';
import styles from './DataCard.module.scss';

export const DataCard = ({
  icon,
  iconSize = 'large',
  className,
  title,
  description,
  disabled = false,
  background = 'white',
  onClick = () => {},
  link = null,
  keyProp = 'data-card',
  showStatusBorder = false,
  iconType = 'default',
  displayStatus = true,
  gap = 'large',
  caption,
  large = false,
  status = {
    text: 'Pending',
    status: 'neutral',
  },
}) => {
  return (
    <ScaleMotion keyProp={keyProp} className="d-flex flex-column u-gap-large" disabled={disabled}>
      <div
        onClick={link ? () => window.open(link, '_blank') : onClick}
        className={cn(styles.root, `d-flex flex-column u-gap-${gap}`, {
          [styles['secondary-card']]: background === 'secondary',
          [styles.disabled]: disabled,
          [`u-border-${status.status}`]: showStatusBorder,
          [className]: className,
        })}>
        <div className={styles.iconWrapper}>
          <IconComponent icon={icon} type={iconType} className={styles.icon} size={iconSize} />
        </div>
        <div className={cn(styles.contentWrapper)}>
          <div className={styles.header}>
            {displayStatus && (
              <StatusPill text={status.text} status={status.status} className={styles.status} />
            )}
          </div>
          <div className={styles.content}>
            <div className="d-flex flex-column u-gap-small">
              {caption && (
                <span className="tertiary-text u-font-size-small u-font-weight-500">{caption}</span>
              )}
              <span
                className={cn('primary-text u-font-weight-500 u-font-size-x-large', {
                  'u-font-size-xx-large': large,
                })}>
                {title}
              </span>
            </div>
            {description && (
              <span className="secondary-text u-font-size-x-small u-font-weight-400">
                {description}
              </span>
            )}
          </div>
        </div>
      </div>
    </ScaleMotion>
  );
};
